export default __webpack_public_path__ + "static/media/define2.d06a64e5.png";